import { render, staticRenderFns } from "./BillTitleAndDescription.vue?vue&type=template&id=d87aaf0c&scoped=true"
import script from "./BillTitleAndDescription.vue?vue&type=script&lang=js"
export * from "./BillTitleAndDescription.vue?vue&type=script&lang=js"
import style0 from "./BillTitleAndDescription.vue?vue&type=style&index=0&id=d87aaf0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87aaf0c",
  null
  
)

export default component.exports